import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';

import { ModelOfStatus } from 'src/database';
import LoadingScreen from '../../components/LoadingScreen';

import { useListStatusController } from '../../controllers/Status/ListStatusController';
import { Toast } from 'primereact/toast';

const StatusList: React.FC = () => {
    const { getStatusListController, handleStatusListController } = useListStatusController();

    if (getStatusListController.loading) {
        return <LoadingScreen />
    };

    const actionBodyTemplate = (Status: ModelOfStatus) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-success p-mr-2" onClick={() => handleStatusListController.openEditDialog(Status)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger" onClick={() => handleStatusListController.openDeleteDialog(Status)} />
            </React.Fragment>
        );
    };

    const editStatusDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={handleStatusListController.closeEditDialog} />
            <Button type="submit" label="Salvar" icon="pi pi-check" className="p-button-text" onClick={() => { getStatusListController.formik.handleSubmit() }} />
        </React.Fragment>
    );

    const deleteStatusDialogFooter = (
        <React.Fragment>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={handleStatusListController.closeDeleteDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text"
                onClick={() => {
                    getStatusListController.selectedStatus && handleStatusListController.removeStatus(getStatusListController.selectedStatus)
                }}
            />
        </React.Fragment>
    );

    const leftStatusToolbar = () => {
        return (
            <Link to="/StatusForm">
                <Button label="Cadastrar status" icon="pi pi-plus" className="p-button-success p-mr-2" />
            </Link>
        );
    };

    return (
        <div>
            <Toast ref={getStatusListController.toast} />
            <div className="p-card p-p-4 datatable-container">
                <Toolbar className="p-mb-4" left={leftStatusToolbar}></Toolbar>

                <DataTable className="p-datatable-sm responsive-table"
                    dataKey="ID" autoLayout scrollHeight={'100%'}
                    scrollable rowHover
                    value={getStatusListController.statusData}
                >
                    <Column field="DESCRICAO" header="STATUS"></Column>
                    <Column body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
                </DataTable>
            </div>

            <Dialog
                className="p-fluid dropdown-visible"
                style={{ width: '450px' }}
                visible={getStatusListController.editDialog}
                onHide={handleStatusListController.closeEditDialog}
                onShow={() => getStatusListController.formik.setValues(getStatusListController.selectedStatus)}
                footer={editStatusDialogFooter}
                header={`Editar status ${getStatusListController.selectedStatus?.DESCRICAO}`}
                modal
            >
                <div className="p-field p-col-12">
                    <label htmlFor="description">Descrição</label>
                    <InputText id="name" type="text"
                        value={getStatusListController.formik.values.DESCRICAO}
                        onChange={getStatusListController.formik.handleChange('DESCRICAO')}
                        required
                    />
                    <div className={classNames("p-invalid popup-fade", {
                        'popup-form-active': getStatusListController.formik.touched.DESCRICAO && getStatusListController.formik.errors.DESCRICAO,
                        'popup-form-inactive': !(getStatusListController.formik.touched.DESCRICAO && getStatusListController.formik.errors.DESCRICAO),
                    })}
                    >{getStatusListController.formik.errors.DESCRICAO}</div>
                </div>
            </Dialog>

            <Dialog
                style={{ width: '450px' }}
                visible={getStatusListController.deleteDialog}
                onHide={handleStatusListController.closeDeleteDialog}
                footer={deleteStatusDialogFooter}
                header="Remover status"
                modal
            >
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {getStatusListController.selectedStatus && <span>Você tem certeza que deseja remover o status <b>{getStatusListController.selectedStatus.DESCRICAO}</b>?</span>}
                </div>
            </Dialog>
        </div>

    );
};

export default StatusList;